import {
  CANVA_CONNECT_API_BASE_URL,
  canva_endpoints,
} from '../utils/constants/canva';
import {
  TAssetCreateDesignRequest,
  TAssetCreateDesignResponse,
  TExchangeAccessTokenRequest,
  TExchangeAccessTokenResponse,
  TGetUploadedAssetRequest,
  TUploadAssetRequest,
  TUploadAssetResponse,
} from '../utils/types/canva';
import { canvaEmptySplitApi } from './base/canvaEmptySplitApi';

const credentials = `${process.env.REACT_APP_CANVA_CLIENT_ID}:${process.env.REACT_APP_CANVA_CLIENT_SECRET}`;

export const canvaService =
  canvaEmptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      exchangeAccessToken: builder.mutation<
        TExchangeAccessTokenResponse,
        TExchangeAccessTokenRequest
      >({
        query: ({ code, refresh_token }) => ({
          url: 'canva/exchange-token',
          method: 'POST',
          data: {
            canva_request_url: `${CANVA_CONNECT_API_BASE_URL}/v1/oauth/token`,
            method: 'POST',
            body: {
              grant_type: code
                ? 'authorization_code'
                : 'refresh_token',
              code_verifier:
                localStorage.getItem('codeVerifier'),
              code,
              refresh_token,
              redirect_uri: `${window.location.origin}${canva_endpoints.REDIRECT}`,
            },
            headers: {
              Authorization: `Basic ${btoa(credentials)}`,
              content_type:
                'application/x-www-form-urlencoded',
            },
          },
        }),
        async onQueryStarted(_args, { queryFulfilled }) {
          queryFulfilled
            .then((data) => {
              localStorage.setItem(
                'canvaAuth',
                JSON.stringify(data.data)
              );
            })
            .catch((error) => error);
        },
      }),
      uploadAsset: builder.mutation<
        TUploadAssetResponse,
        TUploadAssetRequest
      >({
        query: ({ access_token, asset_url }) => ({
          url: 'canva/asset/upload',
          method: 'POST',
          data: {
            canva_request_url: `${CANVA_CONNECT_API_BASE_URL}/v1/asset-uploads`,
            method: 'POST',
            body: {
              asset_url,
            },
            headers: {
              Authorization: `Bearer ${access_token}`,
              content_type: 'application/octet-stream',
            },
          },
        }),
      }),
      getUploadedAsset: builder.mutation<
        TUploadAssetResponse,
        TGetUploadedAssetRequest
      >({
        query: ({ access_token, job_id }) => ({
          url: 'canva/asset/get',
          method: 'POST',
          data: {
            canva_request_url: `${CANVA_CONNECT_API_BASE_URL}/v1/asset-uploads`,
            method: 'GET',
            body: {
              job_id,
            },
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          },
        }),
      }),
      assetCreateDesign: builder.mutation<
        TAssetCreateDesignResponse,
        TAssetCreateDesignRequest
      >({
        query: ({ access_token, asset_id }) => ({
          url: 'canva/asset/createDesign',
          method: 'POST',
          data: {
            canva_request_url: `${CANVA_CONNECT_API_BASE_URL}/v1/designs`,
            method: 'POST',
            body: {
              design_type: {
                type: 'preset',
                name: 'whiteboard',
              },
              asset_id,
              title: 'Nurture Image Editor',
            },
            headers: {
              Authorization: `Bearer ${access_token}`,
              content_type: 'application/json',
            },
          },
        }),
      }),
    }),
  });

export const {
  useExchangeAccessTokenMutation,
  useUploadAssetMutation,
  useGetUploadedAssetMutation,
  useAssetCreateDesignMutation,
} = canvaService;
